<template>
  <div :class="{ active: opened.length > 0 }" class="side-box">
    <span class="side-box__overlay" />
    <div
      :class="{
        opened: opened.indexOf('userEditDetail') >= 0,
        'last-active': opened.indexOf('userEditDetail') == opened.length - 1
      }"
      class="side-box__inner"
    >
      <div class="side-box__header d-flex justify-content-between align-items-center">
        <div class="atom-back atom-back--gray" @click="toggleConfirmation()">
          <div class="atom-back__inner d-flex align-items-center">
            <img src="@/assets/icons/arrows/arr-gray-left.svg" />
            <span>{{ $t("zpet") }}</span>
          </div>
        </div>
        <button class="btn btn-primary" @click="runSave()">
          <div class="atom-icon">
            <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
          </div>
          {{ $t("ulozit") }}
        </button>
      </div>
      <div class="side-box__title">
        <h2 v-if="customer">
          {{ $t("upravitUzivatele") }} {{ editUser.firstName }}
          {{ editUser.lastName }}
          {{ $t("kZakaznikovi") }}
          {{ customer.customerName }}
        </h2>
      </div>
      <div class="side-box__content">
        <div v-if="errors.project" class="text-danger">
          {{ errors.project }}
        </div>
        <div class="my-4">
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("jmeno") }}</span>
            <div
              :class="{
                'has-error': errors.project && !editUser.firstName,
                disabled: false
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!editUser.firstName" class="placeholder">{{ $t("zadejteJmeno") }}</span>
              <input
                v-model="editUser.firstName"
                autofocus
                class="w-100"
                maxlength="40"
                minlength="1"
                placeholder=""
                type="text"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("prijmeni") }}</span>
            <div
              :class="{
                'has-error': errors.project && !editUser.lastName,
                disabled: false
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!editUser.lastName" class="placeholder">{{ $t("zadejtePrijmeni") }}</span>
              <input
                v-model="editUser.lastName"
                autofocus
                class="w-100"
                maxlength="40"
                minlength="1"
                placeholder=""
                type="text"
              />
            </div>
          </div>
          <div class="side-box__row d-flex align-items-center mt-3">
            <span class="side-box__content__label">{{ $t("phone") }}</span>
            <div
              :class="{
                'has-error': errors.project && !editUser.phone,
                disabled: false
              }"
              class="side-box__content__input custom-control__custom-input ml-3"
            >
              <span v-if="!editUser.phone" class="placeholder">{{ $t("zadejteTelefon") }}</span>
              <input v-model="editUser.phone" autofocus class="w-100" maxlength="15" placeholder="" type="text" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <SaveConfirmationModal
      :opened="openedConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleConfirmation"
      @no="closeBox('editUser')"
      @yes="runSave()"
    />
    <InfoConfirmationModal
      :opened="openedInfoConfirmation"
      :text="'requestReceived202'"
      @close="toggleConfirmation"
      @no="closeBox('editUser')"
      @yes="closeBox('editUser')"
    />

    <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="closeModalError()" />
  </div>
</template>

<script>
import axios from "axios"
import ErrorModal from "@/components/confirmations/translatedErrors.vue"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import InfoConfirmationModal from "@/components/confirmations/info.vue"
import { useCustomerStore } from "@/store/modules/customer"
//import Select from "@/components/inputs/select.vue";

export default {
  components: {
    SaveConfirmationModal,
    InfoConfirmationModal,
    ErrorModal
  },
  props: {
    opened: Array,
    user: Object
  },
  setup() {
    const customerStore = useCustomerStore()

    return { customerStore }
  },
  data() {
    return {
      formValidationErrors: [],
      editUser: {
        firstName: "",
        lastName: "",
        phone: "",
        attributes: {
          language: "CZ"
        }
      },
      errors: {
        project: ""
      },
      openedError: false,
      errorsToTranslate: [],
      openedConfirmation: false,
      openedInfoConfirmation: false,
      selectedCustomer: {}
    }
  },
  computed: {
    customer() {
      return this.customerStore.selectedCustomer
    },
    customers() {
      return this.customerStore.customerList
    }
  },
  mounted() {
    this.editUser.firstName = this.user.firstName
    this.editUser.lastName = this.user.lastName
    this.editUser.phone = this.user.phone
  },
  methods: {
    closeModalError() {
      this.openedError = false
    },
    openBox(box) {
      this.$emit("openBox", box)
    },
    closeBox(box) {
      if (box === "editUser") {
        this.$emit("closeBox", box)
      } else {
        this.errors.endpoint = ""
        this.$emit("closeBox", box)
      }
    },
    async runSave() {
      if (this.editUser.firstName == "" || this.editUser.lastName == "" || this.editUser.phone == "") {
        this.errors.project = this.$t("vyplnteOznacenaPole")
        return
      }

      if (!this.isPhoneValid()) {
        this.errors.project = this.$t("TelefonVeSpatnemTvaru")
        return
      }

      this.$store.commit("modals/setWaitingLoader", this.$t("Ukládám data, čekejte prosím..."))

      this.errorsToTranslate = []
      this.errors.project = ""
      // let created = await this.updateUser();

      this.updateUser().then(() => {
        console.log("this.errorsToTranslate.length", this.errorsToTranslate.length)

        if (this.errorsToTranslate.length > 0 || this.openedInfoConfirmation) {
          this.openedError = true
        } else {
          this.closeBox("editUser")
        }

        this.$store.commit("modals/setWaitingLoader", "")
      })
    },
    updateUser() {
      let notifications = []

      return axios
        .put(process.env.VUE_APP_API + "/users/" + this.user.userId, this.editUser)
        .then((response) => {
          /** show confirmation modal on 202 state - there should be delay */
          if (response.status == 202) {
            /*
            notifications.push({
              text: "requestReceived202",
              error: false
            });
            */
            this.openedInfoConfirmation = true
            this.$store.commit("modals/setGlobalNotification", notifications)
          } else if (response.status == 201) {
            notifications.push({
              text: "requestProcessed201",
              error: false
            })
            this.$store.commit("modals/setGlobalNotification", notifications)
          } else {
            return true
          }
        })
        .catch((error) => {
          this.errorsToTranslate.push(error.data)
          return true
        })
    },
    toggleConfirmation() {
      this.openedConfirmation = this.openedConfirmation ? false : true
    },
    selectCustomer(customer) {
      this.selectedCustomer = customer
    },
    isPhoneValid: function () {
      const re = /^\+[0-9]{10,14}$/
      if (re.test(String(this.editUser.phone))) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
